// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__rAtySTj84s{width:600px}`, "",{"version":3,"sources":["webpack://./src/assets/components/shared/transferToAgentModal/components/transferToAgentModal.module.scss"],"names":[],"mappings":"AAEA,mBACE,WAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.modal {\n  width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__rAtySTj84s`
};
export default ___CSS_LOADER_EXPORT___;
